import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


import { HttpService } from 'src/app/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class ListOrdersService {

  constructor(
    private _httpService:  HttpService
  ) { }

  // Objetos Observable y Emiters
  private openCardListOrders$ = new Subject<boolean>();

  emmiterOpenCardListOrders( action: boolean ): void {
    this.openCardListOrders$.next(action);
  }

  getSubjetOpenCardListOrders(): Subject<boolean> {
    return this.openCardListOrders$;
  }

  // Funciones HTTP
  getListOrders() {
    let userId = localStorage.getItem('uid');
    let headers = {
      'dataPedidos': 'true'
    }
    return this._httpService.httpGet(`usuarios/usuario/${userId}`, headers);
  }
  
}
